<template>
  <div>
    <div v-for="(round, index) in rounds" :key="index">
        <div class="game-summary-round">
            <div v-if="gameType === GameType.ROUNDROBIN && (index === 0 || round.id === '1_Finals')">
                <br/>
                <div v-if="index === 0">
                    <span class="is-size-5 game-summary-round-headings">Round-Robin</span>
                </div>
                <div v-if="round.id === '1_Finals'">
                    <span class="is-size-5 game-summary-round-headings">Finals</span>
                </div>
            </div>
            <div class="is-size-5" style="padding-bottom: 6px;">
                <span v-if="gameType === 'Tournament' && round.type === 'Finals'"><u>Finals </u></span>
                <span v-if="gameType != 'Solo'"><u>{{round.title}}</u><br/></span>
            </div>

            <div v-for="(match, index2) in round.matches" :key="match.id">

                <span v-if="gameType != 'Solo'" class="is-size-6">M{{index2+1}}</span>
                <span v-if="gameType == 'Solo'" class="is-size-6">R{{index+1}}</span>

                <span v-for="(matchPlayer, index) in match.matchPlayers" :key="index">
                    <span v-if="matchPlayer.player.id == player.id">
                        <span v-for="(axethrow, index) in matchPlayer.throws" :key="index">
                            <span
                                :class="axethrow.basicScore === 5 ? 'game-summary-throw-bullseye' : 'game-summary-throw'">
                                <span class="is-size-6">{{ axethrow.basicScore }}</span>
                            </span>
                        </span>
                        <span class="is-size-6 game-summary-round-total">
                            <span>{{ $parent.$parent.$parent.calculateTotalThrowsMatch(matchPlayer.throws) }}</span>
                        </span>
                        <span v-if="matchPlayer.bye"><sup>(bye)</sup></span>
                    </span>
                </span>
            </div>
        </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
    .box {
        background-color: #383838;
    }
    .data-holder {
        height: 100px;
    }
    .game-summary {
        border: solid yellow 1px;
        background-color: black !important;
    }
    .game-summary-round-headings {
        color: rgb(59, 142, 250) !important;
    }
    .game-summary-player-name,
    .game-summary-heading-totals {
        color: rgb(59, 142, 250)
    }
    .game-summary-player {
        margin: 10px;
        padding: 10px;
        border: solid gray 1px;
        //display: inline;
        //float: left;
    }
    .game-summary-logo {
        width: 60px;
    }
    .game-summary-user-picture {
        vertical-align: middle;
        width: 40px;
        border-radius: 10px;
    }
    .game-summary-round {
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .game-summary-heading {
        font-family: '28 Days Later';
    }
    .game-summary-heading-logo {
        max-height: 70px !important;
        width: 200px;
        height: 70px;
    }
    .game-summary-heading,
    .game-summary-username,
    .game-summary-datetime,
    .game-summary-round,
    .game-summary-round-total,
    .game-summary-round-avg {
    }
    .game-summary-heading,
    .game-summary-username {
        font-weight: bold;
        margin-bottom: 10px;
    }
    .game-summary-round-title {
        margin-bottom: 10px;
    }
    
    .game-summary-datetime {
        padding: 10px;
    }
    .game-summary-username {
        padding-left: 20px;
    }
    .game-summary-round-total {
        padding-left: 10px;
    }
    .game-summary-game-avg {
        color: rgb(221, 243, 95);
        font-weight: bold;
        margin-top: 10px;
        height: 100%;
        width: 340px;
    }
    .game-summary-game-avg-avg {
        display: inline;
        width: 100%;
        float: left;
    }
    .game-summary-game-avg-total {
        display: inline;
        width: 100%;
        float: left;
    }
    .game-summary-throw-bullseye {
        border: solid gray 1px;
        padding: 2px;
        margin-left: 6px;
    }
    .game-summary-throw {
        border: solid gray 1px;
        padding: 2px;
        margin-left: 6px;
    }
</style>

<script>
import { GameType } from '@/enum/gameType.js';

export default {
  name: "GameSummaryRound",
  data () {
    return {
        GameType
    }
  },
  components: { 
  },
   props: {
    gameType: '',
    player: {},
    rounds: {}
   }, 
  methods: { 

  },
  mounted() {

   }
};
</script>